module.exports = __webpack_public_path__ + "static/zigzag-image3-8a2198e36c85f0be7b412e43a091dd15.png";